import React from "react"

export default function TextEditor(props) {

    const { configText } = props
    return (
        <div
            style={{
                border: '3px solid rgba(84, 156, 211, 1)',
                display: 'flex',
                flexGrow: 1
            }}
        >
            <textarea 
                style={{
                    display: 'flex', 
                    flexGrow: 1,
                    backgroundColor: 'rgb(0, 0, 0)',
                    color: 'rgb(255, 255, 255)',
                }}
            >
                {configText}
            </textarea>
        </div>
    )
}